import { buildModelManager } from "../builder.js";
const DefaultPreceptorRequestSelection = {
  __typename: true,
  id: true,
  agency: true,
  clinicalSite: true,
  createdAt: true,
  createdPreceptorId: true,
  denialReason: true,
  email: true,
  firstName: true,
  institution: true,
  lastName: true,
  notes: { markdown: true, truncatedHTML: true },
  patientEncounterId: true,
  phoneNumber: true,
  priority: true,
  requestedById: true,
  reviewNotes: { markdown: true, truncatedHTML: true },
  reviewedAt: true,
  reviewedById: true,
  shiftId: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "preceptorRequest";
const pluralModelApiIdentifier = "preceptorRequests";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPreceptorRequestSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPreceptorRequestSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorRequestSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorRequestSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorRequestSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorRequestSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorRequestSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createPreceptorRequest",
    operationReturnType: "CreatePreceptorRequest",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      preceptorRequest: { required: false, type: "CreatePreceptorRequestInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPreceptorRequestSelection
  },
  {
    type: "action",
    operationName: "bulkCreatePreceptorRequests",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreatePreceptorRequestsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPreceptorRequestSelection
  },
  {
    type: "action",
    operationName: "updatePreceptorRequest",
    operationReturnType: "UpdatePreceptorRequest",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      preceptorRequest: { required: false, type: "UpdatePreceptorRequestInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPreceptorRequestSelection
  },
  {
    type: "action",
    operationName: "bulkUpdatePreceptorRequests",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdatePreceptorRequestsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPreceptorRequestSelection
  },
  {
    type: "action",
    operationName: "deletePreceptorRequest",
    operationReturnType: "DeletePreceptorRequest",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeletePreceptorRequests",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertPreceptorRequest",
    operationReturnType: "UpsertPreceptorRequest",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      preceptorRequest: { required: false, type: "UpsertPreceptorRequestInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreatePreceptorRequestResult": { hasReturnType: false },
      "... on UpdatePreceptorRequestResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPreceptorRequestSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertPreceptorRequests",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertPreceptorRequestsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultPreceptorRequestSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "preceptorRequestGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PreceptorRequestManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPreceptorRequestSelection,
  operations
);
export {
  DefaultPreceptorRequestSelection,
  PreceptorRequestManager
};
//# sourceMappingURL=PreceptorRequest.js.map
